module.exports = __webpack_public_path__ + "static/media/tasks.1adf8d10.svg";